module.exports = __webpack_public_path__ + "media/images/users/user-6-e5f189e90f7d52ad2726a62c1a576db3.jpg";